const DashboardPage = () => (
  <>
    coming soon ...
  </>
);
export default DashboardPage;
